import { render, staticRenderFns } from "./ShowCredentialTerminalesPuntosColombia.vue?vue&type=template&id=16279348"
import script from "./ShowCredentialTerminalesPuntosColombia.vue?vue&type=script&lang=js"
export * from "./ShowCredentialTerminalesPuntosColombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports